import {Injectable, Injector} from "@angular/core";
import {ReportError} from "app/app.service";

import {BaseListService, BatchRequest, BatchResponse} from "app/services/domain/base.service";
import * as Models from "app/services/proxy/model/models";
import {Lookup} from "framework/services/utils.service";

@Injectable()
export class ComplianceAssessmentControlListService extends BaseListService<Models.ComplianceAssessmentControlListRequest, BatchRequest, Models.ComplianceAssessmentControlDetail>
{
    constructor(inj: Injector)
    {
        super(inj, Models.ComplianceAssessmentControlDetail);
    }

    @ReportError
    public list(listReq: Models.ComplianceAssessmentControlListRequest): Promise<Models.ListResponse>
    {
        return this.domain.apis.compliance.complianceAssessmentControlList(listReq) as Promise<Models.ListResponse>;
    }

    @ReportError
    protected async getBatchResponseImpl(req: BatchRequest): Promise<BatchResponse<Models.ComplianceAssessmentControlDetail>>
    {
        if (!req?.ids?.length) return {results: {}};

        const details                                                  = await this.domain.apis.compliance.complianceAssessmentControlBatch(
            Models.ObjectIdBatchRequest.newInstance({
                                                        ids: this.getSysIds(req)
                                                    })
        );
        const lookup: Lookup<Models.ComplianceAssessmentControlDetail> = {};
        for (const detail of details || [])
        {
            lookup[detail.assessment_control_id] = detail;
        }
        return {results: lookup};
    }

    protected createBatchRequest(listReq: Models.ComplianceAssessmentControlListRequest,
                                 ids: string[]): BatchRequest
    {
        return {ids};
    }

    public async getAllForAssessmentHistoryIds(tenantId: string,
                                               assessmentHistoryIds: string[],
                                               natures?: Models.ControlNature[]): Promise<Models.ComplianceAssessmentControlDetail[]>
    {
        if (!assessmentHistoryIds?.length) return [];

        const request = Models.ComplianceAssessmentControlListRequest.newInstance({
                                                                                     list_context: Models.ListContext.newInstance({
                                                                                                                                      batch_size  : 500,
                                                                                                                                      batch_offset: 0
                                                                                                                                  }),
                                                                                     filters     : Models.ComplianceAssessmentControlDetailFilter.newInstance({
                                                                                                                                                                  tenant_id             : tenantId,
                                                                                                                                                                  assessment_history_ids: assessmentHistoryIds,
                                                                                                                                                                  query                 : natures?.length
                                                                                                                                                                      ? Models.ComplianceControlNatureQueryOperator.newInstance({natures})
                                                                                                                                                                      : undefined
                                                                                                                                                              })
                                                                                 });

        const pairs = await this.getAll(request);
        return pairs?.map(([, detail]) => detail) || [];
    }
}
